// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-FZA","placeholdersHeader":"styles_placeholdersHeader__SyOwe","editorStyle":"styles_editorStyle__1QF6J","placeholdersBox":"styles_placeholdersBox__2EdDE"};